import React from 'react';
import { CheckIcon, XIcon, MinusIcon } from 'lucide-react';
export function Comparison() {
  const comparisonData = [{
    category: 'Warmth',
    heatWraps: {
      value: 'High',
      icon: 'check'
    },
    creams: {
      value: 'Variable',
      icon: 'minus'
    },
    genericPlasters: {
      value: 'None',
      icon: 'x'
    },
    myoQuell: {
      value: 'Gentle & Consistent',
      icon: 'check'
    }
  }, {
    category: 'Delivery of actives',
    heatWraps: {
      value: 'Low',
      icon: 'x'
    },
    creams: {
      value: 'Surface only',
      icon: 'minus'
    },
    genericPlasters: {
      value: 'Basic',
      icon: 'minus'
    },
    myoQuell: {
      value: 'Enhanced',
      icon: 'check'
    }
  }, {
    category: 'Mess/transfer',
    heatWraps: {
      value: 'Clean',
      icon: 'check'
    },
    creams: {
      value: 'Messy',
      icon: 'x'
    },
    genericPlasters: {
      value: 'Clean',
      icon: 'check'
    },
    myoQuell: {
      value: 'Clean',
      icon: 'check'
    }
  }, {
    category: 'Adhesion on knee bends',
    heatWraps: {
      value: 'Poor',
      icon: 'x'
    },
    creams: {
      value: 'N/A',
      icon: 'minus'
    },
    genericPlasters: {
      value: 'Fair',
      icon: 'minus'
    },
    myoQuell: {
      value: 'Excellent',
      icon: 'check'
    }
  }, {
    category: 'Odor',
    heatWraps: {
      value: 'Strong',
      icon: 'x'
    },
    creams: {
      value: 'Strong',
      icon: 'x'
    },
    genericPlasters: {
      value: 'Mild',
      icon: 'minus'
    },
    myoQuell: {
      value: 'Minimal',
      icon: 'check'
    }
  }];
  const renderIcon = icon => {
    switch (icon) {
      case 'check':
        return <CheckIcon size={16} className="text-[#35A67E]" data-id="element-18" />;
      case 'x':
        return <XIcon size={16} className="text-red-500" data-id="element-19" />;
      case 'minus':
        return <MinusIcon size={16} className="text-amber-500" data-id="element-20" />;
      default:
        return null;
    }
  };
  return <section className="py-12 bg-white" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-center mb-8 text-[#0E6B6B]" data-id="element-23">
          How MyoQuell Compares
        </h2>
        <div className="overflow-x-auto" data-id="element-24">
          <table className="w-full min-w-[640px] bg-white rounded-lg shadow-sm" data-id="element-25">
            <thead data-id="element-26">
              <tr className="bg-[#EAF7F3]" data-id="element-27">
                <th className="py-3 px-4 text-left font-bold" data-id="element-28">Feature</th>
                <th className="py-3 px-4 text-center font-bold" data-id="element-29">Heat Wraps</th>
                <th className="py-3 px-4 text-center font-bold" data-id="element-30">Creams</th>
                <th className="py-3 px-4 text-center font-bold" data-id="element-31">
                  Generic Plasters
                </th>
                <th className="py-3 px-4 text-center font-bold bg-[#0E6B6B] text-white" data-id="element-32">
                  MyoQuell™
                </th>
              </tr>
            </thead>
            <tbody data-id="element-33">
              {comparisonData.map((row, rowIndex) => <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-gray-50' : 'bg-white'} data-id="element-34">
                  <td className="py-3 px-4 font-medium" data-id="element-35">{row.category}</td>
                  <td className="py-3 px-4 text-center" data-id="element-36">
                    <div className="flex flex-col items-center" data-id="element-37">
                      <span data-id="element-38">{row.heatWraps.value}</span>
                      <span className="mt-1" data-id="element-39">
                        {renderIcon(row.heatWraps.icon)}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-40">
                    <div className="flex flex-col items-center" data-id="element-41">
                      <span data-id="element-42">{row.creams.value}</span>
                      <span className="mt-1" data-id="element-43">
                        {renderIcon(row.creams.icon)}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center" data-id="element-44">
                    <div className="flex flex-col items-center" data-id="element-45">
                      <span data-id="element-46">{row.genericPlasters.value}</span>
                      <span className="mt-1" data-id="element-47">
                        {renderIcon(row.genericPlasters.icon)}
                      </span>
                    </div>
                  </td>
                  <td className="py-3 px-4 text-center bg-[#EAF7F3]" data-id="element-48">
                    <div className="flex flex-col items-center font-medium" data-id="element-49">
                      <span data-id="element-50">{row.myoQuell.value}</span>
                      <span className="mt-1" data-id="element-51">
                        {renderIcon(row.myoQuell.icon)}
                      </span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}